{
  "metadata": {
    "id": "tokyonight-light",
    "name": "Tokyonight",
    "description": "Портировано из темы «Tokyonight» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "tokyonight.json",
      "project": "folke",
      "url": "https://github.com/folke/tokyonight.nvim",
      "upstreamFile": "packages/ui/src/theme/themes/tokyonight.json",
      "license": "Apache-2.0",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 30.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.456,
      "paletteMaxS": 0.536,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.7,
      "syntaxVsTextMinDeltaE": 20.0,
      "chartsMinDeltaE": 26.5,
      "textSeparationDeltaE": 14.7,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#2e7de9",
      "hover": "#2970d2",
      "active": "#2666bf",
      "foreground": "#000000",
      "muted": "#2e7de980",
      "emphasis": "#2e7de9"
    },
    "surface": {
      "background": "#e1e2e7",
      "foreground": "#273153",
      "muted": "#b3b7c5",
      "mutedForeground": "#353946",
      "elevated": "#9ca2b3",
      "elevatedForeground": "#273153",
      "raised": "#81889e",
      "raisedForeground": "#1a2137",
      "overlay": "#e1e2e733",
      "subtle": "#caccd5"
    },
    "interactive": {
      "border": "#7a8299",
      "borderHover": "#adb0be",
      "borderFocus": "#2e7de9",
      "selection": "#27315324",
      "selectionForeground": "#273153",
      "focus": "#2e7de959",
      "focusRing": "#2e7de947",
      "cursor": "#273153",
      "hover": "#27315317",
      "active": "#27315324"
    },
    "status": {
      "error": "#b33350",
      "errorForeground": "#ffffff",
      "errorBackground": "#b333501a",
      "errorBorder": "#b3335059",
      "warning": "#7a5e36",
      "warningForeground": "#ffffff",
      "warningBackground": "#7a5e361a",
      "warningBorder": "#7a5e3659",
      "success": "#506b34",
      "successForeground": "#ffffff",
      "successBackground": "#506b341a",
      "successBorder": "#506b3459",
      "info": "#006d92",
      "infoForeground": "#ffffff",
      "infoBackground": "#006d921a",
      "infoBorder": "#006d9259"
    },
    "pr": {
      "open": "#506b34",
      "draft": "#424756",
      "blocked": "#7a5e36",
      "merged": "#b15c00",
      "closed": "#b33350"
    },
    "syntax": {
      "base": {
        "background": "#b3b7c5",
        "foreground": "#273153",
        "comment": "#45474f",
        "keyword": "#5c10c0",
        "string": "#134012",
        "number": "#6f3a00",
        "function": "#004f69",
        "variable": "#273153",
        "type": "#51132c",
        "operator": "#0b0c0e"
      },
      "tokens": {
        "commentDoc": "#45474f",
        "stringEscape": "#0b0c0e",
        "keywordImport": "#5c10c0",
        "storageModifier": "#5c10c0",
        "functionCall": "#004f69",
        "method": "#004f69",
        "variableProperty": "#004f69",
        "variableOther": "#273153",
        "variableGlobal": "#6f3a00",
        "variableLocal": "#0b0c0e",
        "parameter": "#273153",
        "constant": "#6f3a00",
        "class": "#51132c",
        "className": "#51132c",
        "interface": "#51132c",
        "struct": "#51132c",
        "enum": "#51132c",
        "typeParameter": "#51132c",
        "namespace": "#51132c",
        "module": "#5c10c0",
        "tag": "#5c10c0",
        "jsxTag": "#5c10c0",
        "tagAttribute": "#004f69",
        "tagAttributeValue": "#134012",
        "boolean": "#6f3a00",
        "decorator": "#5c10c0",
        "label": "#004f69",
        "regexp": "#134012"
      }
    },
    "charts": {
      "series": [
        "#2e7de9",
        "#006d92",
        "#506b34",
        "#7a5e36",
        "#b33350"
      ]
    },
    "chat": {
      "background": "#e1e2e7",
      "userMessage": "#273153",
      "userMessageBackground": "#9ca2b3",
      "assistantMessage": "#273153",
      "assistantMessageBackground": "#b3b7c5",
      "timestamp": "#424756",
      "divider": "#7a8299",
      "typing": "#424756"
    },
    "loading": {
      "spinner": "#2e7de9",
      "spinnerTrack": "#b3b7c5",
      "skeleton": "#b3b7c5",
      "shimmer": "#abafbe"
    },
    "tools": {
      "background": "#b3b7c5",
      "border": "#7a8299",
      "headerHover": "#acb0bf",
      "icon": "#155fc5",
      "title": "#273153",
      "description": "#424756",
      "edit": {
        "added": "#506b34",
        "addedBackground": "#506b341a",
        "removed": "#b33350",
        "removedBackground": "#b333501a",
        "modified": "#006d92",
        "modifiedBackground": "#006d921a",
        "lineNumber": "#424756"
      }
    },
    "markdown": {
      "heading1": "#273153",
      "heading2": "#273153",
      "heading3": "#273153",
      "heading4": "#273153",
      "link": "#1561ca",
      "linkHover": "#2462b8",
      "inlineCode": "#134012",
      "inlineCodeBackground": "#b3b7c5",
      "blockquote": "#424756",
      "blockquoteBorder": "#7a8299",
      "listMarker": "#297ae9",
      "bold": "#273153",
      "italic": "#273153e6",
      "strikethrough": "#424756",
      "hr": "#7a8299"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#b9453f",
        "foreground": "#ffffff",
        "contrast": 5.27
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d29e92",
        "foreground": "#000000",
        "contrast": 9.05
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#936738",
        "foreground": "#ffffff",
        "contrast": 4.96
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d3ce75",
        "foreground": "#000000",
        "contrast": 12.86
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#668f41",
        "foreground": "#000000",
        "contrast": 5.57
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#51c04e",
        "foreground": "#000000",
        "contrast": 9.0
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dc9f",
        "foreground": "#000000",
        "contrast": 12.96
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e7a",
        "foreground": "#000000",
        "contrast": 5.39
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#93dcd7",
        "foreground": "#000000",
        "contrast": 13.46
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#6ca7cd",
        "foreground": "#000000",
        "contrast": 8.05
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#385889",
        "foreground": "#ffffff",
        "contrast": 7.18
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#363fb3",
        "foreground": "#ffffff",
        "contrast": 8.34
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#886ec1",
        "foreground": "#000000",
        "contrast": 5.05
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b446ba",
        "foreground": "#ffffff",
        "contrast": 4.64
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#d292be",
        "foreground": "#000000",
        "contrast": 8.6
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#ba4475",
        "foreground": "#ffffff",
        "contrast": 5.03
      }
    ]
  }
}
